export default {
  words: null,
  highlightedWord: null,
  getMediaPlayer() {
    return this.el.querySelector('.js-media-player')
  },
  mounted() {
    const mediaPlayer = this.getMediaPlayer()
    if (!mediaPlayer) return;

    this.handleEvent('scrub', (e) => {
      mediaPlayer.currentTime = (e.ms * 1) / 1000 + 0.05
      mediaPlayer.play()
    })

    const onTimerUpdate = () => {
      const ms = (mediaPlayer.currentTime || 0) * 1000

      const word = findCurrentWord(this.words, ms)
      if (word) {
        word.tag.classList.remove('hidden')
        word.tag.classList.add('inline')
        if (this.highlightedWord) {
          this.highlightedWord.tag.classList.remove('inline')
          this.highlightedWord.tag.classList.add('hidden')
        }
        this.highlightedWord = word
      }
    }

    mediaPlayer.addEventListener('timeupdate', onTimerUpdate)
  },
  updated() {
    if (!this.words && this.getMediaPlayer()) {
      setTimeout(() => {
        this.words = Array.from(this.el.querySelectorAll('.js-signal')).map((tag) => {
          return {
            tag: tag,
            start_ms: tag.dataset.startMs * 1,
            end_ms: tag.dataset.endMs * 1,
          }
        })
        this.words.sort((a, b) => a.start_ms - b.start_ms)
      }, 500)
    }
  },
  destroyed() {
    // If you want to clean up resources when the LiveView element is removed.
    // const mediaPlayer = this.el.querySelector('.js-media-player')
    // mediaPlayer.removeEventListener('timeupdate')
  },
}

// function throttle(mainFunction, delay) {
//   let timerFlag = null // Variable to keep track of the timer

//   // Returning a throttled version
//   return (...args) => {
//     if (timerFlag === null) {
//       // If there is no timer currently running
//       mainFunction(...args) // Execute the main function
//       timerFlag = setTimeout(() => {
//         // Set a timer to clear the timerFlag after the specified delay
//         timerFlag = null // Clear the timerFlag to allow the main function to be executed again
//       }, delay)
//     }
//   }
// }

function findCurrentWord(words, current_ms) {
  let left = 0
  let right = words.length - 1

  while (left <= right) {
    let mid = Math.floor((left + right) / 2)
    let word = words[mid]

    if (word.start_ms <= current_ms && current_ms <= word.end_ms) {
      // Found the current word
      return word
    } else if (word.start_ms > current_ms) {
      // Go left
      right = mid - 1
    } else {
      // Go right
      left = mid + 1
    }
  }

  // If we get here, it means there is no word being spoken at current_ms
  return null
}
